module.exports = __webpack_public_path__ + "static/media/interaccion-COMUNICACION(B).06960227.svg";